/// <reference path="InsightsLineCell.ts" />
/// <reference path="../webservices/WebService+AI.ts" />

class InsightsChatViewController extends MUIViewController 
{
    static newInstance() : InsightsChatViewController {
        let vc = new InsightsChatViewController("insights-chat-view");
        vc.initWithResource("layout/insights/InsightsChatView.html");
        return vc;
    }

    private closeButton:MUIButton = null;
    private tableView:UITableView = null;
    private messageTextField:MUITextField = null;

    private conversation_id:string = null;
    private messages = [];

    get preferredContentSize(){ return new MIOSize(600, 700); }

    viewDidLoad() {
        super.viewDidLoad();
        this.closeButton = MUIOutlet(this, "close-btn", "MUIButton");
        this.closeButton.setAction(this, function(){
            this.dismissViewController(true);
        });

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this as any;

        this.messageTextField = MUIOutlet(this, "message-tf", "MUITextField");
        this.messageTextField.enabled = false;
    }

    viewDidAppear(animate?) {
        super.viewDidAppear(animate);
        this.messageTextField.becomeFirstResponder();

        let ws = MUIWebApplication.sharedInstance().delegate.webService;
        ws.newConversation((conversationID:string, error:string) => {
            if (error != null) {
                AppHelper.showErrorMessage(this, "ERROR", error);
                return;
            }
            this.conversation_id = conversationID;
            this.messages.addObject({ message: "Hello, what can I do for you?", incoming: true });
            this.tableView.reloadData();

            this.messageTextField.enabled = true;
            this.messageTextField.setOnEnterPress(this, this.sendMessage);         
        });        
    }

    numberOfSections(tableView:UITableView) { return 1; }    
    numberOfRowsInSection(tableView:UITableView, section:number) { return this.messages.length; }
    
    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) { 
        let identifier = this.messages[indexPath.row].incoming ? "InsightsIncomingLineCell" : "InsightsOutgoingLineCell";
        let cell = tableView.dequeueReusableCellWithIdentifier(identifier) as InsightsLineCell;
        cell.item = this.messages[indexPath.row];
        return cell;
    }

    private sendMessage(){
        let message = this.messageTextField.text;
        if (message.length == 0) return;
        this.messages.addObject({ message: message, incoming: false });
        this.tableView.reloadData();
        this.messageTextField.text = "";

        let ws = MUIWebApplication.sharedInstance().delegate.webService;
        ws.sendPrompt(this.conversation_id, message, (response:string, error:string) => {
            if (error != null) {
                AppHelper.showErrorMessage(this, "ERROR", error);
                return;
            }
            this.messages.addObject({ message: response, incoming: true });
            this.tableView.reloadData();
        });
    }

}